export let ModalName;

(function (ModalName) {
  ModalName["CLAIM"] = "modalClaim";
  ModalName["EXTRA_CLAIM"] = "modalClaimExtra";
  ModalName["DETAIL"] = "modalDetail";
  ModalName["ERROR"] = "modalError";
})(ModalName || (ModalName = {}));